import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn } from '@reduxjs/toolkit/src/query';
import { env } from 'next-runtime-env';

import type {
	TVATRequestBodyItem,
	TVATResponseItem,
} from '~shared/api/taxApi/types';

const taxBaseQuery: BaseQueryFn = async (args, api, extraOptions) => {
	return fetchBaseQuery({
		baseUrl: env('NEXT_PUBLIC_MOTO_URL') ?? '',
	})(args, api, extraOptions);
};

export const taxApi = createApi({
	reducerPath: 'taxApi',
	baseQuery: taxBaseQuery,
	endpoints: (build) => ({
		productPricesWithVAT: build.mutation<
			TVATResponseItem[],
			TVATRequestBodyItem[]
		>({
			query: (items) => ({
				url: `/api/Price/decomposeList`,
				method: 'POST',
				body: {
					taxInfoList: items,
				},
			}),
		}),
	}),
});
